import { fadedButtonStyle, filledButtonStyle, largeButtonStyle, smallButtonStyle } from "@/data/styles"

export type CTAButtonLinkSize = 'small' | 'large'
export type CTAButtonLinkVariant = 'filled' | 'faded'

export const sizeStyles: Record<CTAButtonLinkSize, string> = {
  small: smallButtonStyle,
  large: largeButtonStyle
}

export const variantStyles: Record<CTAButtonLinkVariant, string> = {
  filled: filledButtonStyle,
  faded: fadedButtonStyle,
}